import type { InfiniteData } from '@tanstack/react-query';

import type { VehicleListItem } from 'Types/vehicle';
import { getUniqueItemsByKey } from 'Utilities/helpers/getUniqueItemsByKey';

import type { VehicleListFetcher } from '../useFetchVehicleList/useFetchVehicleList.types';

export interface GetVehiclesFromDataProps {
	selectedVehicle?: VehicleListItem;
	vehicles?: InfiniteData<VehicleListFetcher>;
}

const getVehiclesFromData = (vehicles: GetVehiclesFromDataProps['vehicles']) =>
	vehicles?.pages?.reduce((acc: VehicleListItem[], page) => {
		const vehiclesPerPage = page?.data?.vehicles;
		acc.push(...vehiclesPerPage);
		return acc;
	}, []) || [];

export const formatVehicleListData = ({ selectedVehicle, vehicles }: GetVehiclesFromDataProps): VehicleListItem[] => {
	const vehicleListItems = getVehiclesFromData(vehicles);

	return getUniqueItemsByKey(selectedVehicle ? [...vehicleListItems, selectedVehicle] : vehicleListItems, 'id');
};
